import { Checkbox, CheckboxProps, Form, FormItemProps } from 'antd';

interface CheckboxFormProps {
  checkboxProps?: CheckboxProps;
  children?: React.ReactNode;
  classNameCheckbox?: string;
  formProps?: FormItemProps;
}

export const CheckboxForm = ({
  checkboxProps,
  classNameCheckbox,
  formProps,
  children,
}: CheckboxFormProps) => (
  <Form.Item 
    {...formProps}
    hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
  >
    <Checkbox className={classNameCheckbox} {...checkboxProps}>
      {children}
    </Checkbox>
  </Form.Item>
);
